import {
  boxObjClassFieldIds,
  enumObjClassNames,
  kDesiredHolders,
  kEmployeeCostCenter,
  kEmployeeID,
  kEmployeeLocation,
  kEmployeePay,
  kEmployeePositionID,
  kEmployeeSalary,
  kNameID,
  kParentPositionID,
  kPositionBudgetedSalary,
  kPositionCostBandMaximum,
  kPositionCostBandMinimum,
  kPositionDivisionID,
  kPositionEndDate,
  kPositionID,
  kPositionLocation,
  kPositionStartDate,
  kPositionTitleID,
  kTitleID,
  posObjClassFieldIds
} from "../constants";

export const LOCAL_STORAGE_KEY_PLANNING_TABULAR_COLUMNS = "planningTabularColumns";
export const LOCAL_STORAGE_KEY_DIRECTORY_TABULAR_COLUMNS = "directoryTabularColumns";

export const defaultPlanningTabularFields = [
  { fieldID: posObjClassFieldIds.POSITION_TITLE, objClassName: enumObjClassNames.position },
  { fieldID: boxObjClassFieldIds.NAME, objClassName: enumObjClassNames.box },
  { fieldID: posObjClassFieldIds.DESIRED_HOLDERS, objClassName: enumObjClassNames.position },
  { fieldID: posObjClassFieldIds.PARENT_POSITION_ID, objClassName: enumObjClassNames.position },
  { fieldID: posObjClassFieldIds.POSITION_ID, objClassName: enumObjClassNames.position },
  { fieldID: posObjClassFieldIds.POSITION_DIVISION, objClassName: enumObjClassNames.position },
  { fieldID: posObjClassFieldIds.POSITION_LOCATION, objClassName: enumObjClassNames.position }
];

// FieldIDs needed by another fieldID, when it's part of the tabular columns to be shown
export const planningTabularFieldDeps = {
  [posObjClassFieldIds.DESIRED_HOLDERS]: [
    { fieldID: posObjClassFieldIds.HOLDER_COUNT, objClassName: enumObjClassNames.position }
  ],
  [posObjClassFieldIds.PARENT_POSITION_ID]: [
    { fieldID: posObjClassFieldIds.POSITION_TITLE, objClassName: enumObjClassNames.position }
  ]
};

export const TABLE_INITIAL_STATE = {
  columnPinning: {
    left: {
      [enumObjClassNames.position]: [posObjClassFieldIds.POSITION_TITLE],
      [enumObjClassNames.box]: [boxObjClassFieldIds.NAME]
    }
  }
};

export const TABLE_PAGINATION_DEFUALT_STATE = {
  pageIndex: 0,
  pageSize: 25
};

/**
 * Default editable fields for position-based plans.
 * Used in Plan Settings to pre-populate field selections.
 */
export interface DefaultPlanFields {
  holder: readonly string[];
  position: readonly string[];
}
export const DEFAULT_POSITION_PLAN_FIELDS: DefaultPlanFields = {
  holder: [
    kEmployeePositionID,
    kNameID,
    kEmployeeID,
    kTitleID,
    kEmployeeLocation,
    kEmployeeSalary,
    kEmployeePay,
    kEmployeeCostCenter
  ],
  position: [
    kPositionTitleID,
    kPositionID,
    kParentPositionID,
    kDesiredHolders,
    kPositionDivisionID,
    kPositionLocation,
    kPositionStartDate,
    kPositionEndDate,
    kPositionBudgetedSalary,
    kPositionCostBandMinimum,
    kPositionCostBandMaximum
  ]
};
